import { useWindowSize } from '@vueuse/core'
import { watch } from 'vue'

export default () => {
  // console.log('useDynamicVh')
  const setVh = () => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
  }

  // console.log('after setVh')
  // console.log('useWindowSize()', useWindowSize())
  const { width: windowWidth } = useWindowSize()

  // console.log('after useWindowSize')
  watch(windowWidth, setVh, { immediate: true })

  // console.log('end useDynamicVh')
  return {}
}
